export default __webpack_public_path__ + "static/media/bg-ring-4.c179671e.png";